/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'window'
  ],
  function (
    $,
    window
  ) {

    var newRelicReportMethods = {
      newRelicEvent: function newRelicEvent(event, payload) {
        window.sendNewRelicEvent(event, payload);
      },

      reportLocalizer: function reportLocalizer() {
        var Localizer = window.THD_LOCALIZER_AUTO_INIT.Localizer;
        var QSessionID, QUserID;
        if(window.QuantumMetricAPI) {
            QSessionID = window.QuantumMetricAPI.getSessionID();
            QUserID = window.QuantumMetricAPI.getUserID();
        }
        var combinedBothLocalizer = $.extend(true, {},
          Localizer.__getTHDLocalizer(),
          Localizer.__getExistingLocalizer(), {
            QSessionID: QSessionID
          }, {
            QUserID: QUserID
          });
        Localizer.localize().then(function () {
          window.sendNewRelicEvent("THD_LOCALIZER", combinedBothLocalizer);
        });
        Localizer.on(Localizer.event.LOCALIZED_STORE_CHANGED, function () {
          window.sendNewRelicEvent("THD_LOCALIZER", combinedBothLocalizer);
        });
      }
    }

    return {
      init: function initNewRelic() {
        newRelicReportMethods.reportLocalizer();
      }
    }

  });

}.call(window));